import { formateCpf } from "@hooks/masks";

export function buildSearchQuery(searchTerm: string): string {
  const numericTerm = searchTerm.replace(/\D/g, '');
  const formatCpf = formateCpf(numericTerm);

  if (numericTerm.length === 11) {
    return `cpf_3:${formatCpf}`;
  }
  if (numericTerm.length === 14) {
    return `cnpj_regex:${numericTerm}`;
  }
  if (searchTerm.includes('@')) {
    return `email:"${searchTerm}"`;
  }
  return `name:"${searchTerm}"`;
}
